import type { APIAgentPrompt } from '@visorpro/client/dist/types/APIAgentPrompt'
import type { DateTime } from 'luxon'
import { observer } from 'mobx-react-lite'
import type { FC } from 'react'
import { Table } from '../table/table'
import { TableHeader } from '../table/table-header'
import { TableRow } from '../table/table-row'
import { TableTextCell } from '../table/table-text-cell'
import { AgentPromptRow } from './agent-prompt-row'
import { DefaultBadge } from './cells'

export interface AgentPromptsTableProps {
    now: DateTime
    prompts: APIAgentPrompt[]
    hasStoredDefault: boolean
    onShowMenu(e: React.MouseEvent, prompt: APIAgentPrompt): void
    onAssign(prompt: APIAgentPrompt): void
    onViewBaseline(): void
    onDuplicateBaseline(): void
}

export const AgentPromptsTable: FC<AgentPromptsTableProps> = observer(
    ({
        now,
        prompts,
        hasStoredDefault,
        onShowMenu,
        onAssign,
        onViewBaseline,
        onDuplicateBaseline,
    }) => {
        return (
            <Table>
                <thead>
                    <tr>
                        <TableHeader>Name</TableHeader>
                        <TableHeader>Organizations</TableHeader>
                        <TableHeader>Default</TableHeader>
                        <TableHeader>Updated</TableHeader>
                        <TableHeader> </TableHeader>
                    </tr>
                </thead>

                <tbody>
                    {/* Pinned and read-only. It carries the badge while nothing
                        is promoted, because then it IS what chat uses. */}
                    <TableRow data-testid="agent-prompt-baseline-row">
                        {/* Clickable like every other name cell; there is no
                            page to open, so it shows the same dialog as View. */}
                        <TableTextCell
                            data-testid="agent-prompt-baseline-name"
                            title="View the built-in baseline"
                            style={{ cursor: 'pointer' }}
                            onClick={onViewBaseline}>
                            Built-in baseline (code)
                        </TableTextCell>
                        <TableTextCell>
                            <span className="color-dimmed">all, unless overridden</span>
                        </TableTextCell>
                        <TableTextCell>
                            <DefaultBadge isDefault={!hasStoredDefault} />
                        </TableTextCell>
                        <TableTextCell>
                            <span className="color-dimmed">ships with the API</span>
                        </TableTextCell>
                        <td className="table-cell">
                            <span
                                className="text-link"
                                style={{ marginRight: '0.75rem' }}
                                onClick={onViewBaseline}>
                                View
                            </span>
                            <span
                                className="text-link"
                                onClick={onDuplicateBaseline}>
                                Duplicate
                            </span>
                        </td>
                    </TableRow>

                    {prompts.map(prompt => (
                        <AgentPromptRow
                            key={prompt.id}
                            prompt={prompt}
                            now={now}
                            onShowMenu={onShowMenu}
                            onAssign={onAssign}
                        />
                    ))}
                </tbody>
            </Table>
        )
    },
)
